import React from 'react';
import {
  CampaignIcon,
  CheckIcon,
  CopyrightIcon,
  EditIcon,
  EditOffIcon,
  EmojiEmotionsIcon,
  ErrorIcon,
  EventIcon,
  NotificationsIcon,
  PlayArrowIcon,
  SmartDisplayIcon,
  TranslateOutlinedIcon,
  UpdateIcon,
  WarningIcon,
  PersonAddIcon,
  InfoOutlinedIcon,
  PeopleIcon,
  AttachMoneyIcon,
  BarChartIcon,
} from '@rbx/ui';

/**
 * NOTE (@mbae, 03/07/24): Studio and Creator Hub use the same API contract, and
 * given the lack of ability to use MUI in Studio, we maintain a map of strings
 * to icons for consistency in API contract interpretation
 */
const NOTIFICATION_ICON_MAP: Record<string, React.JSX.Element> = {
  CampaignFilledNeutral: <CampaignIcon color='action' />,
  CheckFilledPositive: <CheckIcon color='success' />,
  CopyrightNeutral: <CopyrightIcon color='action' />,
  CopyrightWarning: <CopyrightIcon color='warning' />,
  CopyrightNegative: <CopyrightIcon color='error' />,
  CreateFilledEmphasis: <EditIcon color='info' />,
  CreateFilledNeutral: <EditIcon color='action' />,
  CreateFilledWarning: <EditIcon color='warning' />,
  EditOffFilledNegative: <EditOffIcon color='error' />,
  ErrorFilledError: <ErrorIcon color='error' />,
  EventNeutral: <EventIcon color='action' />,
  HappyFilledNeutral: <EmojiEmotionsIcon color='action' />,
  NotificationBell: <NotificationsIcon color='action' />,
  PlayArrowFilledEmphasis: <PlayArrowIcon color='primary' />,
  PlayArrowFilledNeutral: <PlayArrowIcon color='action' />,
  PlayArrowFilledWarning: <PlayArrowIcon color='warning' />,
  PlayDisabledFilledNegative: <PlayArrowIcon color='error' />,
  TranslateFilledNeutral: <TranslateOutlinedIcon color='action' />,
  UpdateFilledEmphasis: <UpdateIcon color='primary' />,
  UpdateFilledNegative: <UpdateIcon color='error' />,
  UpdateFilledPositive: <UpdateIcon color='success' />,
  UpdateFilledWarning: <UpdateIcon color='warning' />,
  VideoCamFilledNeutral: <SmartDisplayIcon color='action' />,
  VideoCamFilledEmphasis: <SmartDisplayIcon color='primary' />,
  WarningFilledWarning: <WarningIcon color='warning' />,
  PersonAdd: <PersonAddIcon color='info' />,
  InfoFilledEmphasis: <InfoOutlinedIcon color='info' />,
  InfoFilledNeutral: <InfoOutlinedIcon color='action' />,
  PeopleFilled: <PeopleIcon color='action' />,
  AttachMoney: <AttachMoneyIcon color='action' />,
  BarChartNeutral: <BarChartIcon color='action' />,
};

export default NOTIFICATION_ICON_MAP;
